import devoteeKitchen1 from "../../../assets/images/devotee-kitchen1.jpg";
import devoteeKitchen2 from "../../../assets/images/devotee-kitchen2.jpg";
import devoteeKitchen3 from "../../../assets/images/devotee-kitchen3.jpg";
import devoteeKitchen4 from "../../../assets/images/devotee-kitchen4.jpg";

export const devoteeKitchenImages = [
  {
    id: 1,
    image: devoteeKitchen1,
  },
  {
    id: 2,
    image: devoteeKitchen2,
  },
  {
    id: 3,
    image: devoteeKitchen3,
  },
  {
    id: 4,
    image: devoteeKitchen4,
  },
];

export const devoteeKitchen = [
  "Krishna Prasad is one of the most powerful purifiers in this Kali age, and Srila Prabhupad prioritised prasadam distribution, personally cooking and serving visitors to the temple in the west. Our hearts are purified by eating Sri Krishna’s Mahaprasad, allowing devotion to the Lord to enter.",

  "Every day, hundreds of people are served delicious and nutritious Krishna Prasad by the devotee kitchen at Sri SriRadha Giridhariji Temple. Starting early in the morning, they prepare a delicious breakfast and then immediately begin preparing the Lunch Prasad. This Prasad is available at a very low cost throughout the year.",
];
